import { Boundaries } from "@planzone/core";
import { State } from "./types";
import { isInRange } from "./utils";

function handleCreateEventSuccess(
  state: State,
  { event, project }: Boundaries["createEvent"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      events: isInRange(req.filter, {
        startDate: event.startTime,
        endDate: event.endTime,
      })
        ? [...req.calendar.events, { ...event, project }]
        : req.calendar.events,
    },
  }));
}

export { handleCreateEventSuccess };
